import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ModuleGuard({ module: mod, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role === "super_admin") return children;
  const allowed = new Set([...(user.allowed_modules || []), "dashboard", "account"]);
  if (!allowed.has(mod)) {
    return (
      <div data-testid="module-forbidden" className="max-w-xl">
        <h1 className="font-display text-3xl font-black tracking-tighter mb-2">Acceso restringido</h1>
        <p className="text-sm text-muted-foreground">
          No tenés acceso al módulo <code className="text-primary">{mod}</code>. Pedile permiso a un super admin.
        </p>
      </div>
    );
  }
  return children;
}
